import React, { useState, useEffect, useCallback } from 'react';

const Countfot = ({ targetDate }) => {
  const calculateTimeLeft = useCallback(() => {
    const difference = new Date(targetDate) - new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / (1000 * 60)) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }

    return timeLeft;
  }, [targetDate]);

  const [remainingTime, setRemainingTime] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setRemainingTime(calculateTimeLeft());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [calculateTimeLeft]);

  return (
    <div className="text-center flex flex-row justify-center">
      {remainingTime.days !== undefined && (
        <div className="frame mx-2">
          <span className="text-sm font-bold">
            {remainingTime.days} days
          </span>
        </div>
      )}
      {remainingTime.hours !== undefined && (
        <div className="frame mx-2">
          <span className="text-sm font-bold">
            {remainingTime.hours} hours
          </span>
        </div>
      )}
      {remainingTime.minutes !== undefined && (
        <div className="frame mx-2">
          <span className="text-sm font-bold">
            {remainingTime.minutes} minutes
          </span>
        </div>
      )}
      {remainingTime.seconds !== undefined && (
        <div className="frame mx-2">
          <span className="text-sm font-bold">
            {remainingTime.seconds} seconds
          </span>
        </div>
      )}
      {!Object.keys(remainingTime).length && (
        <span className="text-sm font-bold">Welcome to KIPPRA ANNUAL CONFERENCE</span>
      )}
    </div>
  );
};

export default Countfot;
